import { useEffect, useState } from "react";
import {
  Box,
  Button,
  Flex,
  Heading,
  Icon,
  Image,
  Text,
  useToast,
} from "@chakra-ui/react";
import {
  backgroundLight,
  hoverItemColor,
  newBorder,
  textPrimary,
  textSecondary,
  white,
} from "../../utils/colors";
import testupscale from "../../assets/images/testupscale.png";
import styled from "styled-components";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { switchTenantAction } from "../../actions/authActions"; // ✅ import action
import dentacasa from "../../assets/icons/dentacasa.svg";
import { FaArrowRight } from "react-icons/fa6";
// import useIsMobile from "../../../hooks/useIsMobile";
import { Helmet } from "react-helmet";
import LanguageButtonMain from "../../components/buttons/LanguageButtonMain";
import { TbDental } from "react-icons/tb";
import useIsMobile from "../../hooks/useIsMobile";

dayjs.extend(duration);

const TenantSelectPage = () => {
  const { t } = useTranslation();
  const toast = useToast();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  // LANGUAGE
  // const storedLanguage = localStorage.getItem("language");

  // VIDEO
  const [videoLoaded, setVideoLoaded] = useState(false);

  // REDUX
  const authLogin = useSelector((state) => state.authLogin);
  const { userInfo } = authLogin;

  // STATE
  const [tenantModalIsOpen, setTenantModalIsOpen] = useState(false);

  const tenants = userInfo?.tenants?.filter((t) => t.status === "active") || [];

  // HANDLERS
  const handleTenantSwitch = async (tenant) => {
    try {
      await dispatch(switchTenantAction(tenant.slug)); // ✅ dispatch action with slug
      setTenantModalIsOpen(false); // ✅ close modal after switch
      navigate(`/${tenant.slug}/dashboard`); // ✅ navigate
    } catch (err) {
      toast({
        title: "Tenant switch failed.",
        description: err.message,
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    }
  };

  // GOOGLE

  // USE EFFECT
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on page load
    // Check if userInfo is available
  }, [userInfo]);

  // LOGS
  console.log("Tenants:", tenants);
  console.log("User Info:", userInfo);

  return (
    <>
      {/* {!isMobile ? <HeaderMain /> : <HeaderMainMobile />} */}

      <Helmet>
        <title>{t("pageTitle.selectTenantPage")}</title>
        <meta
          name="description"
          content={t("pageDescription.selectTenantPage")}
        />
      </Helmet>

      <Flex
        w="100%"
        h={["100%", "100vh"]}
        align="stretch"
        position={["relative", "relative", "relative"]}
        justify="flex-start"
        bg={white}
        as={motion.div}
        exit={{ opacity: 0, x: 0, transition: { duration: 0.15 } }}
        initial={{ opacity: 0, x: 0, y: 0 }}
        animate={{
          opacity: 1,
          x: 0,
          y: 0,
          transition: { duration: 0.15 },
        }}
      >
        <Box
          position={["absolute", "fixed"]}
          top={["0rem", "2.5rem"]}
          left={["0rem", "2.5rem"]}
          // bg="green"
          p={["1.5rem 1.5rem", "initial"]}
          w={["100%", "100%"]}
          zIndex={1000}
        >
          <Flex w="100%" align="center" justify="space-between">
            <Link to="/">
              <Box h={["20px", "22px"]} w="initial">
                <Image src={dentacasa} h="100%" w="initial" />
              </Box>
            </Link>
            <Flex align="center" justify="flex-end" gap="0rem">
              <LanguageButtonMain />
            </Flex>
          </Flex>
        </Box>

        {/* {!isMobile && ( */}
        {/* <Box
          position={["absolute", "fixed"]}
          top={["1rem", "2rem"]}
          right={["1.5rem", "2.5rem"]}
          left={["initial", "initial"]}
          // bg="green"
          // w="100%"
          zIndex={1000}
        >
          <LanguageButtonMain />
        </Box> */}
        {/* LEFT */}
        <Box
          w="29%"
          position="relative"
          flexShrink={0}
          display={["none", "block"]}
        >
          <Flex w="100%" h="100%" position="relative">
            <Image src={testupscale} w="100%" h="100%" objectFit="cover" />
            <Flex
              position="absolute"
              zIndex="1"
              top="0"
              left="0"
              w="100%"
              h="100%"
              as={motion.div}
              initial={{ opacity: 0, y: 0 }}
              animate={{
                opacity: 1,
                y: 0,
                transition: { delay: 0, duration: 1 },
              }}
            >
              <Video
                playsInline
                autoPlay
                loop
                muted
                onLoadedData={() => setVideoLoaded(true)}
                onError={() => setVideoLoaded(false)}
                style={{ display: videoLoaded ? "block" : "none" }}
                src="https://bucket.mailersendapp.com/0p7kx4xmrvl9yjre/z3m5jgr1omx4dpyo/files/9ca7a800-8d36-414c-a9f1-d5ac05d4a695/videonew2.mp4"
              ></Video>
            </Flex>
          </Flex>
        </Box>

        {/* RIGHT */}
        <Flex
          w="100%"
          align={["flex-start", "flex-start"]}
          justify={["flex-start", "center"]}
          p={["8rem 1.5rem 8rem", "0 0 0 100px"]}
          direction="column"
          overflow={["hidden", "auto"]}
        >
          {/* BACK BUTTON */}
          {/* <Box
            position="absolute"
            top="2rem"
            left={`calc(29% + 2rem)`}
            zIndex={1000}
          >
            <IconButton
              border={`1px solid ${newBorder}`}
              size="md"
              borderRadius="100rem"
              bg={white}
              fontSize="20px"
              icon={<Icon h="0.875rem" as={FaArrowLeft} />}
              // onClick={
              //   currentStep === 1
              //     ? () => window.history.back()
              //     : () => setCurrentStep(currentStep - 1)
              // }
              onClick={() => navigate("/")}
            />
          </Box> */}

          {/* MAIN */}

          <Box w="100%" maxW={["100%", "420px"]}>
            <Box w="100%">
              <Heading
                fontSize="1.875rem"
                fontWeight="700"
                color={textPrimary}
                // mb={6}
              >
                {t("user.selectClinic")}
              </Heading>

              <Text
                color={textSecondary}
                fontWeight="500"
                size="sm"
                m="0.5rem 0 1rem"
              >
                {t("user.selectClinicText")}
              </Text>

              <Flex direction="column" gap="1rem" m="1.5rem 0 0">
                {tenants.map((tenant) => (
                  <Button
                    size="lg"
                    h="4.5rem"
                    borderRadius="1.5rem"
                    bg={white}
                    border={`1px solid ${newBorder}`}
                    key={tenant.tenantID}
                    w="100%"
                    px="1.25rem"
                    onClick={() => handleTenantSwitch(tenant)}
                    _hover={{
                      bg: hoverItemColor,
                      border: `1px solid ${hoverItemColor}`,
                    }}
                    role="group"
                  >
                    <Flex w="100%" justify="space-between" align="center">
                      <Flex align="cemter">
                        {tenant && tenant.logo ? (
                          <Image
                            src={tenant.logo}
                            h="2.5rem"
                            w="2.5rem"
                            borderRadius="100%"
                            objectFit="cover"
                            mr="0.5rem"
                          />
                        ) : (
                          <Flex
                            align="center"
                            justify="center"
                            h="2.5rem"
                            w="2.5rem"
                            borderRadius="100%"
                            bg={backgroundLight}
                            // border={`1px solid ${newBorder}`}
                            mr="0.5rem"
                          >
                            <Icon
                              as={TbDental}
                              color={textSecondary}
                              fontSize="0.875rem"
                            />
                          </Flex>
                        )}

                        <Flex
                          align="flex-start"
                          justify="flex-start"
                          gap="3px"
                          direction="column"
                        >
                          <Text
                            fontSize="1rem"
                            color={textPrimary}
                            textTransform="capitalize"
                            maxW="140px"
                            isTruncated
                          >
                            {tenant.clinicName}
                          </Text>
                          <Text fontSize="sm" fontWeight="500" color="gray.500">
                            {t(`role.${tenant.role}`)}
                          </Text>
                        </Flex>
                      </Flex>

                      <Flex align="center" justify="flex-end">
                        <Flex
                          align="center"
                          justify="center"
                          position="relative"
                          h="1.5rem"
                          w="1.5rem"
                          overflow="hidden"
                          // bg={backgroundLight}
                        >
                          <Icon
                            position="absolute"
                            as={FaArrowRight}
                            color={textSecondary}
                            fontSize="0.875rem"
                            _groupHover={{
                              transform: "translateX(60px)",
                              transition: "transform 0.4s ease",
                              color: textPrimary,
                            }}
                          />
                          <Icon
                            position="absolute"
                            transform="translateX(-60px)"
                            as={FaArrowRight}
                            color={textSecondary}
                            fontSize="0.875rem"
                            _groupHover={{
                              transform: "translateX(0px)",
                              transition: "transform 0.4s ease",
                              color: textPrimary,
                            }}
                          />
                        </Flex>
                      </Flex>
                    </Flex>
                  </Button>
                ))}
                {tenants.length === 0 && (
                  <Text fontSize="sm" color="gray.500">
                    {t("user.noClinicsAvailable")}
                  </Text>
                )}
              </Flex>

              {/* <Box position="relative" py={3}>
                <Divider />
                <AbsoluteCenter bg="white" px="8">
                  <Text
                    textStyle="sm"
                    whiteSpace="nowrap"
                    color={textSecondary}
                  >
                    {t("common.or")}
                  </Text>
                </AbsoluteCenter>
              </Box> */}

              {/* <Box m="0 0 0.5rem">
                <EmailButton
                  // onClick={() => setCurrentStep(2)}
                  label={t("common.continueWithEmail")}
                />
              </Box> */}

              {/* <Agreement /> */}
            </Box>

            {/* <Box>
              <Button onClick={() => setTenantModalIsOpen(true)}>
                Switch Clinic
              </Button>
              <TenantSwitchModal
                isOpen={tenantModalIsOpen}
                onClose={() => setTenantModalIsOpen(false)}
              />
            </Box> */}

            {/* {currentStep === 2 && (
              <RegisterForm
                language={storedLanguage}
                clinicName={clinicName}
                setClinicName={setClinicName}
                registrationEmail={registrationEmail}
                setRegistrationEmail={setRegistrationEmail}
                password={password}
                setPassword={setPassword}
                repeatPassword={repeatPassword}
                setRepeatPassword={setRepeatPassword}
                handleBack={handleBackStepRegisterForm}
                loadingRegister={loadingRegister}
              />
            )}
            {currentStep === 3 && (
              <RegisterVerification
                language={storedLanguage}
                registrationEmail={registrationEmail}
                verificationCode={verificationCode}
                setVerificationCode={setVerificationCode}
                setCurrentStep={setCurrentStep}
                countdown={countdown}
                setCountdown={setCountdown}
                handleBack={handleBackStepRegisterForm}
                loadingVerify={loadingVerify}
              />
            )}
            {currentStep === 4 && (
              <RegisterCreating
                token={token}
                tenantID={tenantID}
                role={role}
                isCreating={isCreating}
                setIsCreating={setIsCreating}
                handleBack={handleBackStepRegisterForm}
              />
            )} */}
          </Box>
        </Flex>
      </Flex>
    </>
  );
};

export default TenantSelectPage;

const Video = styled.video`
  display: block;
  width: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  height: 100%;
`;
